import { render, staticRenderFns } from "./BlogTable.vue?vue&type=template&id=3a3c82d6&"
import script from "./BlogTable.vue?vue&type=script&lang=js&"
export * from "./BlogTable.vue?vue&type=script&lang=js&"
import style0 from "./BlogTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports